import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { Card, CardBody } from "reactstrap";

const EidFront = ({
  imageSRC = null,
  uploadCall,
  title,
  registrationType,
  isremove = false,
  content = "Select Files",
  setisRemove,

  userId,
}) => {
  const [image, setImage] = useState(null);
  const [file, setFile] = useState([]);

  useEffect(() => {
    console.log({ imageSRC });
    if (imageSRC) {
      setImage(imageSRC);
    }
  }, [imageSRC]);

  useEffect(() => {
    console.log("isremove", isremove);
    setisRemove(isremove);
  }, [isremove]);

  const onDrop = (file = []) => {
    if (file && file.length > 0) {
      setFile(file[0]);
      var reader = new FileReader();
      reader.onload = function (e) {
        console.log(file[0]);
        setisRemove(true);
        uploadCall(file[0], reader.result || null);
      };
      reader.readAsDataURL(file[0]);
      console.log(file);
    }
  };

  return (
    <>
      {registrationType !== "NoKYC" && image && (
        <Card style={{ minHeight: "250px" }}>
          <CardBody
            style={{
              fontFamily: "Montserrat-Medium",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="user-registration-image-area">
              <img style={{ width: "100%" }} src={image}></img>
            </div>
          </CardBody>
        </Card>
      )}
      {registrationType === "NoKYC" && image && (
        <>
          <Card style={{ minHeight: "250px" }}>
            <CardBody
              style={{
                fontFamily: "Montserrat-Medium",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="user-registration-image-area">
                <img style={{ width: "100%" }} src={image}></img>
                {isremove && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      marginTop: 10,
                    }}
                  >
                    <i
                      class="fa fa-times"
                      style={{ fontSize: "20px" }}
                      aria-hidden="true"
                      onClick={() => {
                        setFile([]);
                        setImage(null);
                        uploadCall(null, null);
                        // setisRemove(false);
                      }}
                    ></i>
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </>
      )}
      {registrationType === "NoKYC" && !image && (
        <>
          <Card style={{ minHeight: "250px" }}>
            <CardBody
              style={{
                fontFamily: "Montserrat-Medium",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Dropzone
                onDrop={(acceptedFiles) => {
                  console.log(acceptedFiles);
                  onDrop(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <div style={{ cursor: "pointer" }}>{content}</div>
                    </div>
                  </section>
                )}
              </Dropzone>
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
};

export default EidFront;
